import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

/* State and Services */
import { NavigationService } from './core/services/navigation.service';
import { AppSelectors } from 'src/app/core/store/app/app.selectors';

/* Actions */
import { AutoLogin } from 'src/app/core/store/auth/auth.action';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	@Select(AppSelectors.isLoginLayout) isLoginLayout$: Observable<boolean>;

	constructor(private navigationService: NavigationService, private store: Store, private swUpdate: SwUpdate) {}

	ngOnInit(): void {
		this.navigationService.onRouteChanged().subscribe();
		this.store.dispatch(new AutoLogin());

		if (this.swUpdate.isEnabled) {
			this.swUpdate.available.subscribe(() => {
				if (confirm('New version available. Load new version?')) {
					window.location.reload();
				}
			});
		}
	}
}
